<app-loader *ngIf="isLoading"></app-loader>

<div>
  <h4 class="q-heading mb-4">
    <span><img [src]="'IMAGES.BACKARROW'|translate" (click)="goBack()" alt="" class="me-2" /></span>
    {{ "ADDDEVICE.ADDDEVICE" | translate }}
  </h4>
</div>

<div class="bg-white p-3 p-md-4 mb-5 add-device-page">
  <div class="mb-4 mt-2 text-sm">
    {{ "ADDDEVICE.PLEASENETERNAME" | translate }}
  </div>
  <form [formGroup]="addDeviceForm" (ngSubmit)="onAddDevice()" class="q-addDeviceModal-new">
    <div class="form-div">
      <div class="form-group mb-2">
        <label for="name" class="q-form-label">{{ "ADDDEVICE.DEVICENAME" | translate }}<span
            class="text-danger"></span></label>
        <input type="text" #testInput autofocus="true" autocomplete="off" (change)="this.enableAdd=true" maxlength="50"
          (input)="onDeviceNameInput()" (keydown)="removeSpace($event, 'name')"
          (keypress)="keyPressAlphaNumericWithCharacters($event, 'name')" (keypress)="onlyAlphabets($event)"
          class="form-control q-form-control" formControlName="deviceName"
          placeholder="{{ 'ADDDEVICE.NAMETHISDEVICE' | translate }}" />
      </div>
      <ng-container *ngIf="deviceNameErrorMessage">
        <p class="errMessage">
          {{ deviceNameErrorMessage }}
        </p>
      </ng-container>
      <div class="form-group mb-2">
        <label for="prodKey" class="q-form-label">{{ "ADDDEVICE.PRODUCTKEY" | translate
          }}<span class="text-danger"></span></label>
        <div class="d-flex">
          <input type="text" productKeyMask #productKey (paste)="pasteEvent($event)"
            (keydown)="removeSpace($event, 'key')" (keypress)="keyPressAlphaNumericWithCharacters($event, 'key')"
            (keyup)="this.enableAdd=true; verifyProductKeyFromAddDevice($event);" autocomplete="off"
            class="form-control q-form-control" formControlName="productKey"
            placeholder="{{ 'ADDDEVICE.ENTERPRODUCTKEY' | translate }}" [maxlength]="23" />
          <div class="adddevice-showpwdIcon" *ngIf="isProducyKeyVerified">
            <img [src]="'IMAGES.VERIFIEDIMG'|translate" alt="" />
          </div>
          <div class="adddevice-showpwdIcon" *ngIf="isProducyKeyVerifieds">
            <img [src]="'IMAGES.ERRORIMG'|translate" alt="" width="20" height="25" />
          </div>
        </div>

        <ng-container *ngIf="verifyProductKeyErrorMessage || alreadyExist">
          <p class="errMessage">
            {{ verifyProductKeyErrorMessage }}
          </p>
        </ng-container>
      </div>

      <div class="d-none d-md-block">
        <div class="single-device-otp mb-1" *ngIf="!packInfo && isProducyKeyVerified">
          <label for="prodKey" class="q-form-label">{{ "ADDDEVICE.OTPFIND" | translate
            }}
          </label>
          <div class=" mt-2">
            <span class="q-form-label mt-3 mb-3"> Step 1.</span>
            {{ "ADDDEVICE.HOWTOGETOTPONE1" | translate }}
          </div>

          <div>
            <span class="q-form-label mt-3 mb-3"> Step 2.</span>
            {{ "ADDDEVICE.HOWTOGETOTPONE2" | translate }}
          </div>
        </div>
      </div>

      <div class="d-block d-md-none d-lg-none">
        <div class="single-device-otp-mobileview mb-1" *ngIf="!packInfo && isProducyKeyVerified">
          <label for="prodKey" class="q-form-label">{{ "ADDDEVICE.OTPFIND" | translate
            }}
          </label>
          <div class=" mt-2">
            <span class="q-form-label mt-3 mb-3"> Step 1.</span>
            {{ "ADDDEVICE.HOWTOGETOTPONE1" | translate }}
          </div>

          <div>
            <span class="q-form-label mt-3 mb-3"> Step 2.</span>
            {{ "ADDDEVICE.HOWTOGETOTPONE2" | translate }}
          </div>
        </div>
      </div>


      <div class="mt-2 mb-5" *ngIf="packInfo && isProducyKeyVerified">
        <div class="form-group">
          <label for="device" class="q-form-label">{{
            "ADDDEVICE.DEVICES" | translate
            }}</label>
        </div>
        <div class="mw-1000">
          <div class="table-responsive">
            <table class="table activity-table" aria-describedby="Summary">
              <thead class="activity-header">
                <tr>
                  <th></th>
                  <th>{{ "ADDDEVICE.DEVICENAME" | translate }}</th>
                  <th>{{ "ADDDEVICE.EMAIL" | translate }}</th>
                  <th>{{ "ADDDEVICE.IMEINO" | translate }}</th>
                  <th>{{ "ADDDEVICE.ACTIVATIONDATE" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of packInfo; let i = index" class="text-capitalize bg-white">
                  <td>
                    <div class="">
                      <input type="radio" id="option_checkbox{{ item.deviceType }}" name="ritem" class="align-middle"
                        (change)="onDeviceClick($event, item)" />
                      <label for="ritema"></label>
                    </div>
                  </td>
                  <td>
                    {{ item.deviceName | translate }}
                  </td>
                  <td>
                    {{ item.email | translate }}
                  </td>
                  <td>
                    {{ item.macIdOrImei | translate }}
                  </td>
                  <td>
                    {{ item.activateDate | translate }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="multi-device-otp mb-1">
          <label for="prodKey" class="q-form-label">{{ "ADDDEVICE.OTPFIND" | translate
            }}
          </label>
          <div class="mt-2">
            <span class="q-form-label mt-3 mb-3">Step 1. </span>
            {{ "ADDDEVICE.HOWTOGETOTPONE1" | translate }}
          </div>
          <div>
            <span class="q-form-label mt-3 mb-3">Step 2. </span>
            {{ "ADDDEVICE.HOWTOGETOTPONE2" | translate }}
          </div>
        </div>
      </div>

    </div>
    <ng-container *ngIf="showCaptcha">
      <ngx-recaptcha2 #captchaElem siteKey="6LcMjEwhAAAAAE2vVJmSbwo8S4lqZithppOd-qlO" formControlName="captchaToken">
      </ngx-recaptcha2>
    </ng-container>


    <div class="d-flex mt-4">
      <div class="me-3">
        <button type="button" class="q-form-white-submit " (click)="routeback()">
          {{ "ADDDEVICE.CANCEL" | translate }}
        </button>
      </div>

      <div class="me-3">
        <button type="submit" [disabled]="
            addDeviceForm.invalid ||
            isProducyKeyVerified == false ||
            disableAdd == true ||
            disablebtn == true || !enableAdd
          " [ngClass]="
            addDeviceForm.invalid ||
            isProducyKeyVerified == false ||
            disableAdd == true ||
            disablebtn == true || !enableAdd
              ? 'q-invalid-button  '
              : 'submit-btn bg-orgclr '
          ">
          {{ "SIGNUP.SENDOTP" | translate }}
        </button>
      </div>

    </div>
  </form>

  <div *ngIf="pendingOtpData && pendingOtpData?.length != 0">
    <hr>
    <div class="mt-2 mb-5">
      <div class="form-group">
        <label for="device" class="q-form-label">{{
          "ADDDEVICE.PENDINGOTP" | translate
          }}</label>
      </div>

      <div class="mw-1000">
        <div class="table-responsive">
          <table class="table activity-table" aria-label="">
            <thead class="activity-header">
              <tr>
                <th>{{ "ADDDEVICE.DEVICENAME" | translate }}</th>
                <th>{{ "ADDDEVICE.PRODUCTDETAILS" | translate }}</th>
                <th>{{ "SIGNUP.PRODUCTKEY" | translate }}</th>
                <th>{{ "MANAGEUSER.STATUS" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of pendingOtpData" class="text-capitalize bg-white">
                <td>
                  {{ item.deviceName | translate }}
                </td>
                <td>
                  {{ item.productName | translate }}
                </td>
                <td>
                  {{ item.productKey | translate }}
                </td>
                <td>
                  <div class="signuptxt cursor-pointer" (click)="showOtpPopup(item)"> {{ item.status | translate }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Device Popup -->

  <div class="modal" id="OtpPopup" data-bs-backdrop="static">
    <div class="modal-dialog  modal-dialog-centered" id="forgotpwd">
      <div
        class="modal-content border-none rounded-25 shadow-lg relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
        <!-- Modal Header -->
        <div class="text-center mt-4 mb-3">
          <div class="mt-0">
            <h4>
              <app-main-heading>
                <span title> {{ "ADDDEVICE.VERIFICATIONCODE" | translate }}</span>
              </app-main-heading>
            </h4>
          </div>
          <!-- Modal body -->
          <form [formGroup]="addDeviceForm" (ngSubmit)="submitOTP()">
            <div class="">
              <div class="form-group  mt-4 mb-3">
                <div class="d-flex justify-content-center align-items-center mt-1 mb-2">
                  <div>
                    <div class="charClass-new-otp me-2 me-md-3">
                      {{ otpChar }}
                    </div>
                  </div>
                  <div>
                    <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 4, allowNumbersOnly: true }"
                      #ngOtpInput>
                    </ng-otp-input>
                  </div>
                </div>
                <ng-container *ngIf="isOTP && timeOver">
                  <div class="d-flex align-items-center justify-content-center my-2  mt-2 mb-3">
                    <small>
                      {{ "RESENDOT.RESENDOTPIN" | translate }}
                      {{ durationMinutes }}</small>
                  </div>
                </ng-container>
                <div *ngIf="!timeOver && isOTP" class="d-flex my-2 align-items-center justify-content-center mt-2 mb-3">
                  <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
                  <button type="button"
                    class="border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2"
                    (click)="resendOtp()">
                    {{ "LOGIN.RESEND" | translate }}
                  </button>
                </div>
              </div>
              <ng-container *ngIf="otpErrorMessage">
                <p class="errMessage">
                  {{ otpErrorMessage }}
                </p>
              </ng-container>
              <div class="btn-div mt-3 mb-0" style="min-width: 145px; width:auto; padding:10px 24px;">
                <button type="button" [ngClass]="(otpValue != null || otpValue != undefined) && otpValue.length!=4? 'q-invalid-button mb-3 w-100'
                  : 'submit-btn btn-block w-100 bg-orgclr mb-3 cursor-pointer'"
                  [disabled]="otpValue && otpValue.length!=4" (click)="submitOTP()">
                  {{ "LOGIN.VERIFYOTP" | translate }}
                </button>
              </div>
              <div style=" cursor: pointer;position: absolute; top: 25px; right: 25px;">
                <span (click)="cancelOTPManageDevice()"><img src="./assets/images/crossImg.svg" alt=""
                    class="ms-xl-4" /></span>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  </div>